import { useTranslation } from 'react-i18next'

import { sentenceCase } from '#/lib/format'

// The groups of codes the corpus titles, each under `corpus.<group>`.
type CodeGroup =
  | 'concepts'
  | 'activityTypes'
  | 'themes'
  | 'provenance'
  | 'status'
  | 'licences'
  | 'storage'

// The corpus's names for the codes the platform serves. A concept's document
// is content, titles of its sections included, but its id and the catalogue's
// vocabulary are codes the frontend titles: each has copy here, and a code
// without copy (one the platform added first) shows readably, in sentence
// case, rather than as a key.
export function useCorpusLabels() {
  const { t } = useTranslation()
  const codeName = (group: CodeGroup, code: string) =>
    t(`corpus.${group}.${code}`, {
      defaultValue: sentenceCase(code.replaceAll('_', ' ')),
    })
  return {
    codeName,
    conceptName: (id: string) => codeName('concepts', id),
    activityTypeName: (type: string) => codeName('activityTypes', type),
  }
}
